import { Outlet, Navigate } from "react-router";

const PrivateRoute = () => {
    const usuario = JSON.parse(sessionStorage.getItem('user')) 
    if(usuario === null){
        let auth1 = {'token':false}
        return(
            auth1.token ? <Outlet /> : <Navigate to ="/" />
        )
    }else{
        let auth1 = {'token':true}
        return(
            auth1.token ? <Outlet /> : <Navigate to ="/" />
        )
    }
}

export default PrivateRoute